import React, { useEffect, useEffectEvent, useState } from 'react';

function PaymentPage({ paymentToken }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);

  const searchParams = new URLSearchParams(window.location.search);
  const paymentIdFromReturn = searchParams.get('payment_id') || searchParams.get('collection_id');

  const loadPayment = useEffectEvent(async () => {
    try {
      const suffix = paymentIdFromReturn ? `?payment_id=${encodeURIComponent(paymentIdFromReturn)}` : '';
      const res = await fetch(`/api/pagos/${paymentToken}/${suffix}`);
      const json = await res.json();
      if (json.error) {
        setError(json.error);
        return;
      }
      setData(json);
      if (json.estado_comercio === 'activo') {
        setSuccess(json);
      }
    } catch {
      setError('No se pudo cargar el pago.');
    }
  });

  useEffect(() => {
    if (!paymentToken) {
      setError('Link de pago invalido.');
      return;
    }

    loadPayment();
  }, [paymentToken, loadPayment]);

  useEffect(() => {
    if (!paymentToken || success) {
      return undefined;
    }

    const interval = window.setInterval(() => {
      loadPayment();
    }, 5000);

    return () => window.clearInterval(interval);
  }, [paymentToken, success, loadPayment]);

  if (error) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <h1>Pago no disponible</h1>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>Cargando pago...</div>
      </div>
    );
  }

  const payload = success || data;

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <p style={styles.kicker}>Pago Mi Turno</p>
        <h1 style={styles.title}>{payload.nombre_local}</h1>
        <p style={styles.branch}>({payload.sucursal})</p>
        <p style={styles.copy}>Monto: ${payload.payment_amount}</p>

        {!success && (
          <>
            <a href={payload.payment_provider_url} style={styles.button} target="_blank" rel="noreferrer">
              Abrir Suscripcion Mercado Pago
            </a>
            <p style={styles.small}>
              La subscripcion se valida automaticamente por Mercado Pago. Si ya autorizaste, esta pantalla se actualiza sola al confirmar el estado.
            </p>
            {!payload.mercado_pago_configurado && (
              <p style={styles.small}>
                Mercado Pago no esta configurado en el servidor todavia.
              </p>
            )}
          </>
        )}

        {success && (
          <div style={styles.successBox}>
            <p>Comercio habilitado.</p>
            <p><a href={success.admin_url}>Ir al panel admin</a></p>
            <p><a href={success.client_url}>Ver link cliente</a></p>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: 'linear-gradient(160deg, #f6f1e7 0%, #d9ebe4 100%)',
    fontFamily: 'Georgia, serif'
  },
  card: {
    maxWidth: '560px',
    width: '100%',
    background: '#fffdf8',
    borderRadius: '28px',
    padding: '32px',
    textAlign: 'center',
    boxShadow: '0 24px 80px rgba(24, 39, 34, 0.16)'
  },
  kicker: {
    textTransform: 'uppercase',
    letterSpacing: '0.16em',
    fontSize: '12px'
  },
  title: {
    marginBottom: '8px'
  },
  branch: {
    marginTop: 0,
    color: '#5e5e5e'
  },
  copy: {
    fontSize: '18px'
  },
  button: {
    display: 'inline-block',
    marginTop: '18px',
    padding: '16px 28px',
    borderRadius: '999px',
    background: '#0f7b6c',
    color: '#fff',
    textDecoration: 'none'
  },
  small: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#5b5b5b',
    marginTop: '18px'
  },
  successBox: {
    marginTop: '18px',
    padding: '18px',
    borderRadius: '18px',
    background: '#eef9f1'
  }
};

export default PaymentPage;